export const isAdminPath = path => {
  const re = /^\/admin\/?.*/;
  return re.test(path);
};

export const isAuthPath = path => {
  const re = /^\/(auth)\/(?!logout).*/;
  return re.test(path) || path === '/admin/login';
};
